import React from 'react';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

import MuiFormControl from '@mui/material/FormControl';
import MuiFormLabel from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiRadio from '@mui/material/Radio';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';
import classNames from 'classnames';
export interface IRadioDef {
  value: string;
  label: string;
  disabled?: boolean;
}

interface IProps {
  label: string;
  value: string;
  onChange: (newValue: string) => void;
  /** These will be spread down as props to the FormControlLabel component */
  radioDefs: IRadioDef[];
  row?: boolean;
  disabled?: boolean;
  paddingLeft?: CommonPropsAndTypes.StandardSpacingType;
  marginTop?: CommonPropsAndTypes.StandardSpacingType;
  fullWidth?: boolean;
  classes?: any;
  noFocusColor?: boolean;
  required?: boolean;
}

const styles = (theme: Theme) => ({
  formControl: {},
  group: {
    marginTop: theme.spacing(1),
  },
  formLabel: {
    color: theme.palette.text.primary,
  },
  noFocusColor: {
    '&.Mui-focused': {
      color: theme.palette.text.primary,
    },
  },
  paddingLeftNone: {
    paddingLeft: 0,
  },
  paddingLeftDense: {
    paddingLeft: theme.spacing(1),
  },
  paddingLeftNormal: {
    paddingLeft: theme.spacing(2),
  },
  marginTopNone: {
    marginTop: 0,
  },
  marginTopDense: {
    marginTop: theme.spacing(2),
  },
  marginTopNormal: {
    marginTop: theme.spacing(3),
  },
  fullWidth: {
    width: '100%',
  },
});

export class EDRadioGroup extends React.Component<IProps> {
  handleChange = (event: React.ChangeEvent<unknown>, value: string) => {
    this.props.onChange(value);
  };

  render() {
    const showRequiredError =
      Boolean(this.props.required) && !this.props.value && !this.props.disabled;

    return (
      <MuiFormControl<'fieldset'>
        component={'fieldset'}
        className={classNames(
          this.props.classes.formControl,
          {
            [this.props.classes.marginTopNone]: this.props.marginTop === 'none',
            [this.props.classes.marginTopDense]:
              this.props.marginTop === 'dense',
            [this.props.classes.marginTopNormal]:
              !this.props.marginTop || this.props.marginTop === 'normal',
          },
          {
            [this.props.classes.paddingLeftNone]:
              !this.props.paddingLeft || this.props.paddingLeft === 'none',
            [this.props.classes.paddingLeftDense]:
              this.props.paddingLeft === 'dense',
            [this.props.classes.paddingLeftNormal]:
              this.props.paddingLeft === 'normal',
          },
          { [this.props.classes.fullWidth]: this.props.fullWidth }
        )}
        disabled={this.props.disabled}
        required={this.props.required}
        error={showRequiredError}
      >
        <MuiFormLabel
          component={'legend'}
          required={this.props.required}
          error={showRequiredError}
          className={classNames(this.props.classes.formLabel, {
            [this.props.classes.noFocusColor]: this.props.noFocusColor,
          })}
        >
          <strong>{this.props.label}</strong>
        </MuiFormLabel>
        <MuiRadioGroup
          aria-label={this.props.label}
          name={this.props.label}
          value={this.props.value}
          onChange={this.handleChange}
          className={this.props.classes.group}
          row={this.props.row}
        >
          {this.props.radioDefs.map(radioDef => (
            <MuiFormControlLabel
              key={radioDef.value}
              control={<MuiRadio color="secondary" />}
              {...radioDef}
            />
          ))}
        </MuiRadioGroup>
      </MuiFormControl>
    );
  }
}

export default withStyles(EDRadioGroup, styles);
